module.exports = __webpack_public_path__ + "img/banner_m.3104cda7.png";